require('normalize.css/normalize.css');
require('./main.scss'); 
import css from './kontakt.scss'; 